import React, { useEffect, useState, useMemo } from "react";
import "../../priceAnimation.css";

export default function PriceAnimation({ actual, offer }) {
  const [animate, setAnimate] = useState(false);

  // Dynamically calculate font size based on number length
  const dynamicFontSize = useMemo(() => {
    const maxLength = Math.max(
      actual?.toString().length || 0,
      offer?.toString().length || 0
    );

    // Clamp automatically prevents too small or too large
    if (maxLength <= 5) return "text-xl";      // large prices (normal size)
    if (maxLength <= 7) return "text-lg";      // medium shrink
    return "text-base";                        // long numbers → shrink more
  }, [actual, offer]);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 200);
  }, []);

  return (
    <div className={`price-container flex flex-col leading-tight`}>
      <span
        className={`actual-price ${animate ? "strike" : ""} 
        ${dynamicFontSize} text-gray-500 line-through`}
      >
        {actual}
      </span>

      <span
        className={`offer-price ${animate ? "reveal" : ""} 
        ${dynamicFontSize} font-bold text-green-600`}
      >
        {offer}
      </span>
    </div>
  );
}
